module.exports = __webpack_public_path__ + "static/media/cover.2e9d95a5.jpg";